import * as React from "react";
import { Form, Segment, TextArea, Grid, Header, Button, List, Checkbox, Dropdown, Message, FormField, GridColumn, GridRow, ListItem, MessageHeader, MessageList, MessageItem } from "@/components/bp/bp-ui";
import { Formik } from "formik";
import * as yup from "yup";
import { TranslationContext } from "../../../Contexts/TranslationContext";
import { ClientResources, FamilialSearchCaseRunCreateModel } from "@app/api2/api";
import { BPSection } from "@app/components/React/Common/BPSection";
import { BPButton } from "@/components/bp/bpbutton";
import { BPCheckbox } from "@/components/bp/bpcheckbox";

interface IInformactionFamilialSearchProps {
    model: FamilialSearchCaseRunCreateModel;
    onComplete: (values: any) => void;
    router: any;
    //rangeOfContributors: boolean;
}

class InformactionFamilialSearchState {
    initialValues: InformationFamilialSearchState;
    populationOptions: any[];
    selectAllReference: boolean;
    selectAllEvidence: boolean;
    selectAllQualityCheck: boolean;
}

export class InformationFamilialSearchState {
    description: string = '';
    populationId: number = -1;
    // evidence: Array<any> = [];
    references: Array<any> = [];
    // qualityCheckCases: Array<any> = [];

}

export class InformactionFamilialSearch extends React.Component<IInformactionFamilialSearchProps, InformactionFamilialSearchState> {
    

    InformactionFamilialSearchValidationSchema = yup.object().shape({
        description: yup.string().label(window.translation.caseRun.runDescription),
        //hdUnknowns: yup.number().min(0).integer().max(4).required().label(window.translation.caseRun.hdUnknowns),
        //hpUnknowns: yup.number().min(0).integer().max(4).required().label(window.translation.caseRun.hpUnknowns),
        populationId: yup.number().required().label(window.translation.common.population)
    });

    InformactionFamilialSearchRangeValidationSchema: yup.SchemaOf<any>;
    form: any = React.createRef();

    constructor(props, context) {
        super(props, context);

        let $this = this;


        this.InformactionFamilialSearchRangeValidationSchema = yup.object().shape({
            description: yup.string().label(window.translation.caseRun.runDescription),
            rangeOfContributorsMin: yup.number().min(1).integer().max(5).required().label(window.translation.caseRun.rangeOfContributors),
            rangeOfContributorsMax: yup.number().min(1).integer().max(5).required().label(window.translation.caseRun.rangeOfContributors),

            //hdUnknowns: yup.string().required().label(window.translation.caseRun.hdUnknowns).test('hdUnknowns', window.translation.caseRun.numberOfContributorsError, function (value) {
            //    const { path, createError } = this;

            //    let parsed = $this.parseNumberOfContributors(value);

            //    if (parsed.min < 0 || parsed.max < 0)
            //        return false;

            //    return true;
            //}),

            //hpUnknowns: yup.string().required().label(window.translation.caseRun.hpUnknowns).test('hpUnknowns', "", function (value) {
            //    const { path, createError } = this;

            //    let parsed = $this.parseNumberOfContributors(value);

            //    if (parsed.min < 0 || parsed.max < 0)
            //        return createError({ path, message: window.translation.caseRun.numberOfContributorsError });

            //    return true;
            //}),

            someth: yup.string().label(window.translation.caseRun.hpUnknowns).test('someth', "", function (value) {
                const { path, createError } = this;
                let hp = $this.form.current.values.hp.filter(x => x.selected);
                let hd = $this.form.current.values.hd.filter(x => x.selected);
                let hpNotInHd = hp.filter(p => !hd.some(d => d.id == p.id));
                if (hpNotInHd.length! - 1) {
                    return createError({ path, message: window.translation.caseRun.onlyOnePoiCanBeSelectedError });
                }

                return true;
            }),
        });

        this.state = {
            initialValues: {
                description: this.props.model.description || "",
                populationId: this.props.model.populationId && this.props.model.populations.some(x => x.id == this.props.model.populationId) ? this.props.model.populationId : null,
                //hd: this.props.model.hd,
                //hp: this.props.model.hp,
                // evidence: this.props.model.evidence,
                references: this.props.model.references,
                // qualityCheckCases: this.props.model.qualityCheckCases
            },
            populationOptions: this.props.model.populations.map((p) => ({ key: p.id, value: p.id, text: p.name })),
            selectAllReference: false,
            selectAllEvidence: false,
            selectAllQualityCheck: false,
        };
    }

    parseNumberOfContributors = (noc: string) => {
        const sign = (noc || 0).toString().startsWith("-") ? "-" : "+";
        if (sign == "-")
            noc = noc.substring(1, noc.length);

        const range = noc != null ? noc.split("-") : null;

        if (range && range.length > 0) {
            // if (sign == "-")
            //     range
            const min = parseInt(range[0]) * (sign == "-" ? -1 : 1);
            const max = parseInt(range[range.length - 1]);

            return { min: Math.min(min, max), max: Math.max(min, max) };
        }

        return { min: 1, max: 2 };
    };

    calcUnknownHx = (nocMin: number, nocMax: number, contributors: Array<{ selected: boolean }>) => {
        let unknowns = [];
        for (let noc = nocMin; noc <= nocMax; noc++) {
            let unknown = noc;
            //let hd = values.hd;
            //let hp = values.hp;
            unknown = noc - contributors.filter(h => h.selected).length;
            unknowns.push(unknown);
        }
        return unknowns.join("-");
    }

    formRender = ({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldTouched, setFieldValue }) => {
        var state = this.state;
        const dropdownChange = async (e, data, name?) => {
            if (name) {
                await setFieldValue(name, data.value);
                if (name == "numberOfContributors") {
                    await recalcUnknownHd(data.value, data.value);
                    await recalcUnknownHp(data.value, data.value);
                }
            } else {
                await setFieldValue("populationId", data.value);
            }
        };

        const descriptionUpdate = async (e, data) => {
            await setFieldValue("description", data.value);
        }

        const evidenceChecked = async (id, i, value) => {
            var evidence = values.evidence;
            evidence[i].selected = value;
            await setFieldValue("evidence", evidence);
        }

        const qualityControlChecked = async (id, i, value) => {
            var qualityCheckCases = values.qualityCheckCases;
            qualityCheckCases[i].selected = value;
            await setFieldValue("qualityCheckCases", qualityCheckCases);
        }

        const hpChecked = async (id, i, value) => {
            const hp = values.references;
            hp[i].selected = value;
            await setFieldValue("references", hp);
        }

        const selectAllReferenceChecked = (value) => {
            const hp = values.references;
            for (let p of hp)
                p.selected = value;

            this.setState({ ...this.state, selectAllReference: value });
        }

        const selectAllEvidenceChecked = (value) => {
            const hp = values.evidence;
            for (let p of hp)
                p.selected = value;

            this.setState({ ...this.state, selectAllEvidence: value });
        }

        const selectAllQualityControlChecked = (value) => {
            const hp = values.qualityCheckCases;
            for (let p of hp)
                p.selected = value;

            this.setState({ ...this.state, selectAllQualityCheck: value });
        }

        const recalcUnknownHd = async (nocMin, nocMax) => {
            await setFieldValue('hdUnknowns', this.calcUnknownHx(nocMin, nocMax, values.hd));
            this.setState({ ...this.state });
        }

        const recalcUnknownHp = async (nocMin, nocMax) => {
            await setFieldValue('hpUnknowns', this.calcUnknownHx(nocMin, nocMax, values.hp));
            this.setState({ ...this.state });
        }


        return (<TranslationContext.Consumer>{t =>
            <Form onSubmit={handleSubmit}>
                <FormField>
                    <label>{t.caseRun.runDescription}</label>
                    <TextArea value={values.description} onChange={descriptionUpdate} name="description" />
                </FormField>
                <FormField>
                    <label>{t.common.population}</label>
                    <Dropdown search selection options={this.state.populationOptions} value={values.populationId} onChange={dropdownChange} />
                </FormField>
                <Grid>
                    <GridRow columns={3}>
                        {values.references.length > 0 &&
                            <GridColumn>
                                {/* <ItemsList
                                    header={'asdfasfd'}
                                    items={values.references}
                                    renderRow={(e,i) => <TableRow key={e.id}>
                                        <TableCell><BPCheckbox checked={e.selected} label={e.name} onClick={(ev, data) => (hpChecked(e.id, i, data.checked))} /></TableCell>
                                    </TableRow>}
                                /> */}
                                <Header attached="top"><BPCheckbox label={t.common.referencePlural} checked={this.state.selectAllReference} onClick={(ev, data) => (selectAllReferenceChecked(data.checked))} /></Header>
                                <BPSection scrolling>
                                    <List relaxed divided>
                                        {values.references.map((e, i) => (
                                            <ListItem key={`ref-${e.id}`}>
                                                <BPCheckbox checked={e.selected} label={e.name} onClick={(ev, data) => (hpChecked(e.id, i, data.checked))} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </BPSection>
                            </GridColumn>
                        }
                        {values.evidence?.length > 0 &&
                            <GridColumn>
                                <Header attached="top"><BPCheckbox label={t.common.evidence} checked={this.state.selectAllEvidence} onClick={(ev, data) => (selectAllEvidenceChecked(data.checked))} /></Header>
                                <BPSection scrolling>
                                    <List relaxed divided>
                                        {values.evidence.map((e, i) => (
                                            <ListItem key={`ev-${e.id}`}>
                                                <BPCheckbox checked={e.selected} label={e.name} onClick={(ev, data) => (evidenceChecked(e.id, i, data.checked))} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </BPSection>
                            </GridColumn>
                        }
                        {values.qualityCheckCases?.length > 0 &&
                            <GridColumn>
                                <Header attached="top"><BPCheckbox label={t.common.qualityControlCases} checked={this.state.selectAllQualityCheck} onClick={(ev, data) => (selectAllQualityControlChecked(data.checked))} /></Header>
                                <BPSection scrolling>
                                    <List relaxed divided>
                                        {values.qualityCheckCases.map((e, i) => (
                                            <ListItem key={`qch-${e.caseId}`}>
                                                <BPCheckbox checked={e.selected} label={e.name} onClick={(ev, data) => (qualityControlChecked(e.caseId, i, data.checked))} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </BPSection>
                            </GridColumn>
                        }
                    </GridRow>
                </Grid>
                {Object.keys(errors).length > 0 &&
                    <Message negative>
                        <MessageHeader>{t.caseRun.errorsOnForm}</MessageHeader>
                        <MessageList>
                            {Object.keys(errors).map((k) => (<MessageItem key={k}>{errors[k]}</MessageItem>))}
                        </MessageList>
                    </Message>
                }
                <Segment basic clearing>
                    <BPButton floated="right" type="submit" positive primary>{t.caseRun.next}</BPButton>
                </Segment>
            </Form>}</TranslationContext.Consumer>);
    };

    onSubmit = (values, bag) => {
        this.props.onComplete(values);
        // this.props.router.history.push("/parameters");
    };

    render() {
        return (
            <Formik innerRef={this.form} enableReinitialize={true} initialValues={this.state.initialValues} onSubmit={this.onSubmit} validationSchema={this.InformactionFamilialSearchValidationSchema}>
                {(props) => {
                    return this.formRender(props)
                }}
            </Formik>
        );
    }
}